import { RealEstateTenantDocuments } from '../../../../../../@types/real-estate-api-types'
import { ContentStateInterface } from '../../../../../../@types/types'

export const tenantDocumentsToApi = (insertionData: ContentStateInterface): RealEstateTenantDocuments => {
  return {
    solvency: insertionData.solvency ?? false,
    income: insertionData.income ?? false,
    rental: insertionData.rental ?? false,
    selfReport: insertionData.selfReport ?? false,
    identification: insertionData.identification ?? false,
  }
}
